import gql from 'graphql-tag'
import { BMDialogFloor, RemoveFloorSpecificBusinessHourInput } from '@api'
import { BMDialogFloorFragment } from '@api/fragments'
import client from '@stores/apollo'
import handleFetchResult from '@utils/handleFetchResult'

interface IPayload {
  removeFloorSpecificBusinessHour: { floors: BMDialogFloor[] }
}

const mutateHandler = handleFetchResult<IPayload, BMDialogFloor[]>({
  handler: (data) => data.removeFloorSpecificBusinessHour.floors,
  name: 'Dialog Floor',
})

export default function removeFloorSpecificBusinessHours(
  input: RemoveFloorSpecificBusinessHourInput
): Promise<BMDialogFloor[]> {
  return client.gql.mutate({ mutation, variables: { input } }).then(mutateHandler)
}

const mutation = gql`
  mutation RemoveFloorSpecificBusinessHour($input: RemoveFloorSpecificBusinessHourInput!) {
    removeFloorSpecificBusinessHour(input: $input) {
      floors {
        ...BMDialogFloorFragment
      }
    }
  }
  ${BMDialogFloorFragment}
`
